import React, { useCallback, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CircularStepper from 'src/components/FormStepper/CircularStepper';
import { selectAvalBuroFormResult } from 'src/store/selectors/avalBuroFormSelectors';
import CurrentStep from '../CurrentStep';
import ResultAvalView from '../ResultAvalView';

const stepperLabels = [
  { label: 'AVAL_BURO_FORM.STEPS.ZERO' },
  { label: 'AVAL_BURO_FORM.STEPS.ONE' },
  { label: 'AVAL_BURO_FORM.STEPS.TWO' },
  { label: 'AVAL_BURO_FORM.STEPS.THREE' },
  { label: 'AVAL_BURO_FORM.STEPS.FOUR' },
  { label: 'AVAL_BURO_FORM.STEPS.FIVE' }
];

const AvalBuroForm = () => {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({});
  const formResult = useSelector(selectAvalBuroFormResult);
  const { t } = useTranslation();

  const handleNext = useCallback(
    values => {
      setData(prev => ({ ...prev, ...values }));
      setStep(prev => prev + 1);
    },
    []
  );

  const handleNextStep = useCallback(() => {
    setStep(prev => prev + 1);
  }, []);

  const handleBack = useCallback(() => {
    setStep(prev => prev - 1);
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        flex: 1,
        paddingY: { xs: '16px', sm: '20px' },
        overscrollBehavior: 'contain'
      }}
    >
      {formResult ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            width: '100%',
            maxWidth: { xs: 600, md: 800, lg: 960 },
            px: { xs: 2, sm: 3 }
          }}
        >
          <ResultAvalView />
        </Box>
      ) : (
        <>
          <CircularStepper activeStep={step} steps={stepperLabels} disableEnumerations />
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', mt: 0.5, mb: 1, fontWeight: 500 }}
          >
            {t('AVAL_BURO_FORM.STEP_LABEL', { current: step, total: stepperLabels.length })}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: { xs: 'flex-start', md: 'center' },
              width: '100%',
              maxWidth: { xs: 600, md: 800, lg: 960 },
              px: { xs: 2, sm: 3 },
              mt: { xs: 3, sm: 4 }
            }}
          >
            <CurrentStep
              activeStep={step}
              data={data}
              onNext={step === 6 ? handleNextStep : handleNext}
              onBack={handleBack}
            />
          </Box>
        </>
      )}
    </Paper>
  );
};

export default AvalBuroForm;
